export class AppointmentTimeSlotModel {
  time: string;
  label: string;
}
